
import FormValidatorIndicator from "../form-validation/formvalidator-indicator";
const formvalidatorIndicator = new FormValidatorIndicator();
const checkboxes = document.querySelectorAll('.csf_disable-input');
let initialValues = [];

checkboxes.forEach(checkbox => {
    checkbox.checked=false;
    checkbox.addEventListener('change', function () {

        const form = this.closest('form');
        const disableFieldNamefor = form.name + "_" + this.getAttribute('disablefieldname');
        const disableFieldName = form.name + "[" + this.getAttribute('disablefieldname') + "]";
        const inputToDisable = form.querySelector(`input[name="${disableFieldName}"]`);
        const label = form.querySelector(`[for="${disableFieldNamefor}"]`);
        const inputClassList = inputToDisable.getAttribute("class").split(' ');

        if (this.checked) {
            if (inputToDisable) {
                inputToDisable.value = '';
                initialValues[disableFieldName] = {
                    inputInit: inputToDisable.cloneNode(true),
                    labelInit: label.cloneNode(true),

                };
                if (label.classList.contains("required")) {
                    label.classList.remove("required");
                }
                inputToDisable.setAttribute('disabled', 'disabled');
                inputToDisable.removeAttribute('required');
                inputToDisable.removeAttribute('data-initial-constraints');

                let updatedClassesList = inputClassList.filter(className => !className.includes("cvf_"));
                inputToDisable.setAttribute("class", updatedClassesList.join(' '));
                inputToDisable.correct = true;
                formvalidatorIndicator.correctIndicator(inputToDisable);
            }
        } else {
            if (inputToDisable && initialValues[disableFieldName]) {
                const {inputInit, labelInit} = initialValues[disableFieldName];

                inputToDisable.setAttribute("class", Array.from(inputInit.classList).join(' '));
                if(inputInit.getAttribute('required')){
                    inputToDisable.setAttribute("required", inputInit.getAttribute('required'));
                }
                if(inputInit.getAttribute('data-initial-constraints')){
                    inputToDisable.setAttribute("data-initial-constraints", inputInit.getAttribute('data-initial-constraints'));
                }
                inputToDisable.removeAttribute('disabled');
                if (labelInit.classList.contains("required")) {
                    label.classList.add("required");
                }
                inputToDisable.correct = false;
                inputToDisable.value = '';
            }
        }
    });
});
